import Card from 'react-bootstrap/Card';
import '../signiteCandidateForm.css';
import { Alert, Form as BSForm } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { Col, Row } from 'react-bootstrap';
import { ProfessionalReferenceForm } from './professionalReferenceFragment';
import { OtherDetailsForm } from './otherDetailsFragment';
import { LanguageProficiencyForm } from './languageProficiencyFragment';
import { FamilyDetailsForm } from './familyDetailsFragment';
import { InterestsForm } from './interestsFragment';
import { DiscreetReferenceCheckForm } from './DiscreetReferenceChecksFragment';
import SigniteButton from '../../../../ui-elements/signite-button/signiteButton';
import JSONPretty from 'react-json-pretty';
import { ValueAddSchema } from '../../validations/valueAddValidationSchema';
import _ from 'lodash';
import { reverseTransformValueAddData } from '../../transformers/valueAddTransformer';
import { useEffect, useState } from 'react';
import Loader from 'react-spinner-loader';
import { useRef } from 'react';
import { CandidateService } from '../../../../../services/candidateService';
import { MasterDataService } from '../../../../../services/masterDataService';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const CandidateValueAddsForm = ({ onSubmit, componentRef, valueAddData, saveCurrentValues }) => {
  const [countryCodes, setCountryCodes] = useState([]);
  const [valueAddFromStore, setValueAddFromStore] = useState({});
  const [cityOptions, setCityOptions] = useState([]);

  useEffect(() => {
    CandidateService.getAllCallingCodes().then((data) => {
      setCountryCodes([{ callingCode: '', displayText: '--Select--' }, ...data.data]);
      if (valueAddData && valueAddData.valueAdds) {
        try {
          let revTransedValAdd = reverseTransformValueAddData(valueAddData.valueAdds);
          setValueAddFromStore(revTransedValAdd);
          console.log('Value Adds from store:', revTransedValAdd);
        } catch (e) {
          console.error(e);
        }
      }
    });
  }, []);

  useEffect(() => {
    MasterDataService.getAllCities().then(res => {
      const cities = res.data || [];
      setCityOptions(["Anywhere in India", ...cities]);
    });
  }, []);

  const initialValues = {
    professionalReference: [],
    languageProficiency: [],
    children: [],
    interests: [],
    additionalInfo: [],
  };


  const handleDownload = (type, filePath, fileName) => {
    CandidateService.downloadFile(type, filePath)
      .then((response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || 'document.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  return (
    <Formik
      initialValues={valueAddFromStore || initialValues}
      onSubmit={async (values) => {
        if (!values.additionalInfo || typeof values.additionalInfo === 'string') {
          values.additionalInfo = [];
        }
        onSubmit(values, 'value-adds');
      }}
      enableReinitialize={true}
      validationSchema={ValueAddSchema}
      innerRef={componentRef}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
        const [loader, setLoader] = useState(false);
        const fileUploadHandler = (data) => {
          setFieldValue(`additionalInfo[0].originalName`, data.originalName);
          setFieldValue(`additionalInfo[0].path`, data.path);
        };

        const inputFile3 = useRef(null);
        const removeFile = (field) => {
          setFieldValue(field, []);
          inputFile3.current.value = '';
        };
        const handleFileChange = (event) => {
          console.log(event.target.files[0]);
          if (event.target.files[0]) {
            const formData = new FormData();
            formData.append('file', event.target.files[0]);
            CandidateService.uploadFile(formData, event.target.id, fileUploadHandler, setLoader);
          }
        };
        saveCurrentValues(values);
        return (
          <>
            {window.debug && window.debug == true && (
              <Card className="mb-3">
                <Card.Title>DEBUG</Card.Title>
                <Card.Body className="side-pad-24">
                  <JSONPretty data={values}></JSONPretty>
                  <JSONPretty data={errors}></JSONPretty>
                  <JSONPretty data={touched}></JSONPretty>
                </Card.Body>
              </Card>
            )}

            <Card>
              <Card.Title>Professional Reference</Card.Title>
              <Card.Body className="side-pad-24">
                <ProfessionalReferenceForm
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  values={values}
                  errors={errors}
                  touched={touched}
                  countryCodes={countryCodes}
                ></ProfessionalReferenceForm>
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
              <Card.Title>Linkedin Profile</Card.Title>
              <Card.Body className="side-pad-24">
                <Row className="mb-3">
                  <BSForm.Group as={Col} controlId="linkedInProfile">
                    <BSForm.Label>Link to Linkedin Profile</BSForm.Label>
                    <BSForm.Control
                      type="text"
                      name={`linkedInProfile`}
                      placeholder="LinkedIn Profile Link"
                      onChange={handleChange}
                      onBlur={(el) => {
                        handleBlur(el);
                      }}
                      value={values.linkedInProfile}
                      className={_.get(errors, `linkedInProfile`) ? 'form-control erroredInput' : 'form-control'}
                    />
                    <span className="errorMessage">{_.get(errors, 'linkedInProfile')}</span>
                  </BSForm.Group>
                </Row>
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Other Details</Card.Title>
              <Card.Body className="side-pad-24">
                <BSForm className="signite-form">
                  <OtherDetailsForm
                    cityOptions={cityOptions}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    errors={errors}
                    values={values}
                  />
                </BSForm>
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Language Proficiency*</Card.Title>
              <Card.Body className="side-pad-24">
                <BSForm className="signite-form">
                  <LanguageProficiencyForm
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                  />
                </BSForm>
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Family Details</Card.Title>
              <Card.Body className="side-pad-24">
                <FamilyDetailsForm handleChange={handleChange} values={values} />
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Interests</Card.Title>
              <Card.Body className="side-pad-24">
                <InterestsForm handleChange={handleChange} values={values} />
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Discreet Reference Checks</Card.Title>
              <Card.Body className="side-pad-24">
                <Alert>For internal use only</Alert>
                <DiscreetReferenceCheckForm
                  handleChange={handleChange}
                  values={values}
                  errors={errors}
                  touched={touched}
                  countryCodes={countryCodes}
                  handleBlur={handleBlur}
                />
              </Card.Body>
            </Card>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Additional Information</Card.Title>
              <Card.Body className="side-pad-24">
                <Row style={{ paddingLeft: 20 }}>
                  <div className="file-upload d-flex align-items-center">
                    <BSForm.Group as={Col} controlId={'fileUpload'}>
                      <SigniteButton
                        variant="primary"
                        className="signiteUploadButton"
                        onClick={() => inputFile3.current.click()}
                      >
                        Browse..
                      </SigniteButton>
                      <input
                        type="file"
                        id="ADD_INFO"
                        ref={inputFile3}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept=".doc,.docx,.pdf"
                      />
                      {(_.get(values, `additionalInfo[0].originalName`) && (
                        <span>
                          <a
                            onClick={() =>
                              handleDownload(
                                "additionalInfo",
                                _.get(values, `additionalInfo[0].path`),
                                _.get(values, `additionalInfo[0].originalName`)
                              )
                            }
                            style={{
                              marginLeft: 10,
                              cursor: "pointer",
                              color: '#eb4b15'
                            }}
                          >
                            {_.get(values, `additionalInfo[0].originalName`)}
                          </a>
                          {
                            <a
                              onClick={() => removeFile(`additionalInfo`)}
                              style={{ marginLeft: 5, cursor: 'pointer', color: '#eb4b15' }}
                            >
                              <FontAwesomeIcon icon={faMinusCircle} size="sm" /> <span>Remove</span>
                            </a>
                          }
                        </span>
                      )) ||
                        `Or drop file here`}
                    </BSForm.Group>
                  </div>
                </Row>
              </Card.Body>
            </Card>
          </>
        );
      }}
    </Formik>
  );
};

export default CandidateValueAddsForm;